module.exports = __webpack_public_path__ + "img/Paso1.0a23f7c1.svg";